import { render } from "./ShopEditPage.vue?vue&type=template&id=3082b2be&scoped=true"
import script from "./ShopEditPage.vue?vue&type=script&lang=js"
export * from "./ShopEditPage.vue?vue&type=script&lang=js"

import "./ShopEditPage.vue?vue&type=style&index=0&id=3082b2be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3082b2be"]])

export default __exports__